import Immutable from 'immutable';

export const NO_CERTIFICATE = 'no_certificate';
export const ASQA_ACCREDITED_CERTIFICATE = 'asqa_accredited_certificate';
export const CERTIFICATE_OF_COMPLETION = 'certificate_of_completion';
export const OPENLEARNING_CERTIFICATE = 'openlearning_certificate';

export const CertificationTypes = Immutable.List([
  NO_CERTIFICATE,
  OPENLEARNING_CERTIFICATE,
  CERTIFICATE_OF_COMPLETION,
  ASQA_ACCREDITED_CERTIFICATE,
]);
